import { conditions, justAudio } from "helpers";
import { ConditionName } from "interfaces";
import { qualityChangeRequestLog, sendFluentLog } from "../../../../../logs";
import { createSettings } from "redux-share/actions/user.actions";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setUserSettings } from "redux-share/slices/userSlice";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const ChevronRightIcon = dynamic(() => import("../../icon-components/chevronRight"));

const QualityLevels = ({ setSection }: any) => {

    const dispatch = useAppDispatch();
    const { qualityLevels, qualityBitrates, manualQuality, autoQuality } = useAppSelector(({ controller: { qualityLevels, qualityBitrates, manualQuality, autoQuality, showMiniPlayer } }) => ({ qualityLevels, qualityBitrates, manualQuality, autoQuality, showMiniPlayer }), shallowEqual);
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);
    useAppSelector(({ videoData: { params, videoElementSizeInfo } }) => ({ params, videoElementSizeInfo }), shallowEqual);

    const handleTickSelectedQuality = (index: number, qualityLevel: number) => {
        if (conditions(ConditionName.isAutoQuality) && qualityLevel === -1) return true;
        else return !conditions(ConditionName.isAutoQuality) && settings.quality === index;
    }

    return (
        <div id="qualityLevels" className="animate__animated animate__fadeIn">
            <div className="pl-flex pl-items-center pl-cursor-pointer" onClick={() => setSection("main")}>
                {!conditions(ConditionName.isMiniPlayer) && <ChevronRightIcon className="pl-absolute !pl-right-[5px] pl-w-5 pl-h-5 pl-stroke-gray-800 dark:pl-stroke-dark-5" />}
                <p className={`pl-text-[15px] pl-font-medium pl-py-3 ${conditions(ConditionName.isMiniPlayer) ? "pl-relative pl-right-3" : "pl-pr-12"}`}>کیفیت</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                {qualityLevels.map((qualityLevel: number, index: number) => (
                    <li
                        key={index}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-font-medium pl-pr-12 pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 ${handleTickSelectedQuality(index, qualityLevel) && "pl-tick-icon pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"}`}
                        onClick={() => {
                            sendFluentLog(qualityChangeRequestLog(qualityLevel === -1 ? "auto" : `${qualityLevel}P`));
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                            dispatch(setUserSettings({ ...settings, quality: qualityLevel === -1 ? -1 : index }));
                            createSettings({ ...settings, quality: qualityLevel === -1 ? null : index });
                            setSection("main");
                        }}
                    >
                        <span className="pl-w-full">
                            {qualityLevel === -1
                                ? `خودکار ${conditions(ConditionName.isAutoQuality) ? `(${qualityLevels[autoQuality ?? manualQuality!]}P - ${qualityBitrates[autoQuality ?? manualQuality!]})` : ""}`
                                : ((+qualityLevel === justAudio && conditions(ConditionName.isLiveParam)) ? "فقط صدا" : `${qualityLevel}P - ${qualityBitrates[index]}`)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    )
};

export default QualityLevels;